import React from 'react';
import styled, { css } from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { label14, p14 } from '../../styles/typography';
import { Container } from '../container/container';

export enum AlertVariant {
  Info = 'info',
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
}

const Host = styled.div<{ variant: AlertVariant }>`
  ${p14};
  padding: ${gutter(2)} ${gutter(3)};
  strong {
    font-weight: 500;
  }

  display: flex;
  flex-direction: row;

  /* Background */
  ${(props) => {
    switch (props.variant) {
      case AlertVariant.Info:
        return css`
          background-color: ${color('blue10')};
        `;
      case AlertVariant.Success:
        return css`
          background-color: ${color('green20')};
        `;
      case AlertVariant.Danger:
        return css`
          background-color: ${color('red20')};
        `;
      case AlertVariant.Warning:
        return css`
          background-color: ${color('orange20')};
        `;
    }
  }}
`;

const Title = styled.span`
  ${label14};
`;

interface AlertProps {
  title?: string;
  copy: React.ReactNode;
  variant?: AlertVariant;
  action?: React.ReactNode;
  style?: any;
}

export const Alert = ({
  title,
  copy,
  variant = AlertVariant.Info,
  action,
  style,
}: AlertProps) => {
  return (
    <Host variant={variant} style={style}>
      <Container>
        {title && <Title>{title}: </Title>}
        {copy}
      </Container>
      {action}
    </Host>
  );
};
